import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import FieldSet from 'flarum/common/components/FieldSet';
import Select from 'flarum/common/components/Select';
const SETTINGS_PAGE = 'flarum/forum/components/SettingsPage';
export const PREFERENCE_KEY = 'champis-species.dataSource';

/**
 * Adds a "gbif"/"col" Select to the user's own settings page, letting them
 * pick whether species pages show GBIF's own name/classification (the
 * default - GBIF's own Backbone Taxonomy is frozen, but remains every other
 * feature's single source of truth) or Catalogue of Life's - see
 * SpeciesLookupService::getSpeciesByIdCf()'s own docblock ($preferCol) for
 * exactly what switching to 'col' does and doesn't change. Same "extend
 * settingsItems" pattern as champis-theme-large's own addThemeLargeSetting.tsx,
 * a Select instead of a Switch since this is a 2-way choice, not a toggle.
 *
 * Only shown to an actor with champis-species.chooseDataSource (see
 * extend.php's own ForumResource field) - the feature is still rolling
 * out, so it's restricted to whoever an admin trusts to try it (typically
 * moderators/admins) rather than offered to every member by default. Same
 * "UI convenience, real boundary is elsewhere" caveat as canManageSpecies's
 * own nav-link gating - a value saved before this permission was revoked
 * still takes effect server-side, this only hides the control to change it.
 *
 * Checked inside the settingsItems callback below (render time), not at
 * this function's own top level - addNavLink.tsx's own canManageSpecies/
 * canViewMissingSpecies checks follow the same rule, for the same reason:
 * app.initializers themselves run before app.forum's own attributes are
 * necessarily populated, so reading one eagerly here threw and took the
 * whole champis-species extension down with it ("n'a pas réussi à
 * s'initialiser", confirmed the hard way 2026-09-21) - by the time a
 * caller actually opens the Settings page, app.forum is fully loaded.
 */
export default function addDataSourceSetting() {
  extend(SETTINGS_PAGE, 'oninit', function () {
    this.champisSpeciesDataSourceLoading = false;
  });
  extend(SETTINGS_PAGE, 'settingsItems', function (items) {
    if (!app.forum.attribute('canChooseColDataSource')) {
      return;
    }
    items.add('champisSpeciesDataSource', m(FieldSet, {
      className: "Settings-champisSpeciesDataSource FieldSet--min",
      label: app.translator.trans('champis-species.forum.settings.heading')
    }, m(Select, {
      options: {
        gbif: app.translator.trans('champis-species.forum.settings.option_gbif'),
        col: app.translator.trans('champis-species.forum.settings.option_col')
      },
      value: this.user.preferences()?.[PREFERENCE_KEY] ?? 'gbif',
      disabled: this.champisSpeciesDataSourceLoading,
      onchange: value => {
        this.champisSpeciesDataSourceLoading = true;
        this.user.savePreferences({
          [PREFERENCE_KEY]: value
        }).then(() => {
          this.champisSpeciesDataSourceLoading = false;
          m.redraw();
        });
      }
    }), m("span", {
      className: "helpText"
    }, app.translator.trans('champis-species.forum.settings.help'))), -60);
  });
}